import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ModalController, ToastController} from '@ionic/angular';
import {SelfEvaluationRecord} from '../../../../../self-evaluation/_interfaces/self-evaluation-record.interface';
import {BaseClass} from '../../../../classes/base';
import {QuestionConfig, QuestionTypeConfig, QuestionViewType} from '../../../../interfaces/process-config.interface';
import {TranslationService} from '../../../../services/translation.service';
import {UtilService} from '../../../../services/util.service';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: 'app-slider-questions',
    templateUrl: './slider-questions.component.html',
    styleUrls: ['./slider-questions.component.scss', '../../question-types.component.scss'],
})
export class SliderQuestionsComponent extends BaseClass implements OnInit {
    public readonly QuestionViewType = QuestionViewType;
    public highlightSelfOrManagerEvalAnswer: boolean;

    @Input() question: QuestionConfig;
    @Input() formGroup: UntypedFormGroup;
    @Input() descriptionTooltip: string = '';
    @Input() hideQuestionTitle: boolean = false;
    @Input() isManagerComment: boolean = false;
    @Input() evaluation?: SelfEvaluationRecord = null;
    @Input() managerAnswer: boolean = false;
    @Input() setTooltip: (question: QuestionConfig, vIndex: number) => boolean;
    @Input() openDescriptionConcept: (title: string, description: string, index: number) => boolean;
    @Input() showRequiredBadge: (formGroup: UntypedFormGroup, index: number) => boolean;
    @Input() getQuestionAnswer: (question: QuestionConfig, gIndex?: number) => boolean;
    @Input() setRangeValue: (key: string, value: string, typeConfig?: QuestionTypeConfig, index?: number) => boolean;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _utilService: UtilService,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
    }


    ngOnInit() {
        this.highlightSelfOrManagerEvalAnswer = this._configService.settings.features.highlightSelfOrManagerEvalAnswer;
    }
}
